export default "__VITE_ASSET__Fvbnbcvh__"